import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20 pb-8" }
const _hoisted_2 = { class: "max-w-screen-2xl m-auto" }
const _hoisted_3 = { class: "py-10" }
const _hoisted_4 = { class: "space-y-4 list-decimal list-inside" }
const _hoisted_5 = { class: "font-bold" }
const _hoisted_6 = { class: "font-bold" }
const _hoisted_7 = { class: "pl-5 mt-2 space-y-1 list-disc list-inside" }
const _hoisted_8 = { class: "font-bold" }
const _hoisted_9 = { class: "font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "text-2xl font-bold mb-5" }, "Log modifiche fornitore", -1)),
        _createElementVNode("ol", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modifiche, (m) => {
            return (_openBlock(), _createElementBlock("li", null, [
              _cache[2] || (_cache[2] = _createTextVNode(" L'utente ")),
              _createElementVNode("span", _hoisted_5, _toDisplayString(m.user.name), 1),
              _cache[3] || (_cache[3] = _createTextVNode(" ha modificato il fornitore il ")),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$filters.toDate(m.created_at)), 1),
              _cache[4] || (_cache[4] = _createTextVNode(". ")),
              _createElementVNode("ul", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(m.new_values, (v, k) => {
                  return (_openBlock(), _createElementBlock("li", null, [
                    _cache[0] || (_cache[0] = _createTextVNode("Il campo ")),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(k), 1),
                    _cache[1] || (_cache[1] = _createTextVNode(" è stato cambiato in ")),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.qualificheFornitore[v]), 1)
                  ]))
                }), 256))
              ])
            ]))
          }), 256))
        ])
      ])
    ])
  ]))
}